<div class="details-changes-card">
  <ng-container *ngIf="selectedContactDetailsChanges$ | async as selectedContactDetailsChanges; else noChanges">
    <div class="contact-details-header">
      <div class="contact-title-container">
        <span class="title-md">{{ selectedContactDetailsChanges.contactName }}</span>
        <app-status-pill [statusPill]="selectedContactDetailsChanges.statusPill" />
      </div>
      <app-paginator
        *ngIf="contactDetailsChangesLength$ | async as contactDetailsChangesLength"
        class="contact-details-paginator"
        [selectedIndex]="selectedContactIndex$ | async"
        (selectedIndexChange)="setSelectedContactIndex($event)"
        [totalPages]="contactDetailsChangesLength" />
    </div>
    <div class="changes-container">
      <app-employer-contact-submission-details-field-change
        *ngIf="!(previousNotApplicable$ | async); else notApplicable"
        [changeType]="SubmissionDetailsFieldChangeTypeEnum.Previous"
        [detailsChanges]="formattedPreviousContactChanges$ | async">
        <div *ngIf="previousChangeHasSigningAuthority$ | async" class="signing-authority-row">
          <img src="assets/icons/primary/Check-Circle.svg" alt="" aria-hidden="true" />
          <span class="signing-authority-label" i18n>Has Signing Authority</span>
        </div>
        <div
          *ngIf="!(previousChangeHasSigningAuthority$ | async) && (newChangeHasSigningAuthority$ | async)"
          class="signing-authority-spacer"></div>
      </app-employer-contact-submission-details-field-change>

      <app-employer-contact-submission-details-field-change
        [changeType]="SubmissionDetailsFieldChangeTypeEnum.New"
        [detailsChanges]="formattedNewContactChanges$ | async">
        <div *ngIf="newChangeHasSigningAuthority$ | async" class="signing-authority-row">
          <img src="assets/icons/primary/Check-Circle.svg" alt="" aria-hidden="true" />
          <span class="signing-authority-label" i18n>Has Signing Authority</span>
        </div>
        <div
          *ngIf="(previousChangeHasSigningAuthority$ | async) && !(newChangeHasSigningAuthority$ | async)"
          class="signing-authority-spacer"></div>
      </app-employer-contact-submission-details-field-change>
    </div>
  </ng-container>
</div>

<ng-template #notApplicable>
  <div class="changes-card">
    <span class="change-label" i18n>Previous</span>
    <span class="no-changes" i18n>Not Applicable</span>
  </div>
</ng-template>

<ng-template #noChanges>
  <span class="no-changes" i18n>No Changes</span>
</ng-template>
